/* istanbul ignore file */
import { Button } from '../Button/Button';
import { Box } from '@mui/material';

const CollapseControls = ({
  isExpandButtonShown,
  isCollapseButtonShown,
  collapseAll,
  expandAll,
}: {
  isExpandButtonShown: boolean;
  isCollapseButtonShown: boolean;
  collapseAll: () => void;
  expandAll: () => void;
}) => {
  return (
    <Box display="flex" alignItems="center" flexGrow={0} flexShrink={0}>
      {isExpandButtonShown && (
        <Button variant="outlined" onClick={expandAll}>
          Expand All
        </Button>
      )}
      {isCollapseButtonShown && (
        <Button variant="outlined" sx={{ marginLeft: isExpandButtonShown ? '12px' : 0 }} onClick={collapseAll}>
          Collapse All
        </Button>
      )}
    </Box>
  );
};

export default CollapseControls;
